import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../config";

export default function useSocket(currentUserId) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUserId) return;

    const protocol = window.location.protocol === "https:" ? "wss" : "ws";

    const host = BASE_URL.replace(/^https?:\/\//, "");

    const socket = new WebSocket(`${protocol}://${host}ws/status?userId=${currentUserId}`);

    window.testSocket = socket;

    socket.onopen = () => console.log("✅ WebSocket connected");

    socket.onmessage = (event) => {
      try {
        const message = event.data;
        console.log("📩 Message from server:", message);

        if (message === "FORCE_LOGOUT") {
          toast.error("Your account has been deactivated. Logging out...");

          sessionStorage.removeItem("token");
          localStorage.removeItem("authToken");
          localStorage.removeItem("userId");
          localStorage.removeItem("themeColor");

          setTimeout(() => navigate("/"), 3000);
        }
      } catch (err) {
        console.error("⚠️ Failed to parse WebSocket message:", event.data, err);
      }
    };

    socket.onclose = () => console.log("❌ WebSocket disconnected");
    socket.onerror = (error) => console.error("⚠️ WebSocket error:", error);

    return () => socket.close();
  }, [currentUserId]);
}
